import { indices } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            精选九大专题合集，深度挖掘娱乐世界的每一个精彩角落
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indices.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <span className="font-heading text-lg font-bold text-accent-600">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}